import {instance} from "../../config/axios-cnf";


export const apiGetKioskLog = (callback, error) => {
    instance.get("/api/v2/kiosk/log")
        .then(response => callback(response.data))
        .catch(err => error(err))
}
